import styled from 'styled-components'

export const PageWrapper = styled.div``
export const TitleWrapper = styled.div``
export const ThirPartyButtonsWrapper = styled.div``
export const ClientRiskWrapper = styled.div``
export const ClientRiskButtonsWrapper = styled.div``
export const BusinessRelationshipWrapper = styled.div``
export const BusinessRelationshipOptionsWrapper = styled.div``
